import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useGetMostSellingProductsQuery } from '../../../features/api/apiSlice';
import { addToCart } from '../../../features/cartProducts/cartSlice';

const BestSeller = () => {
    const { data: products, isLoading, isError } = useGetMostSellingProductsQuery();
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const handleAddToCart = (product) => {
        dispatch(
            addToCart(product)
        )
    }


    let content = null;
    if (isLoading) {
        content = <h1>Loading...</h1>
    }
    if (!isLoading && isError) {
        content = <h1>There was an error</h1>
    }
    if (!isLoading && !isError && products?.length === 0) {
        content = <h1>{t('utils.notFound')}</h1>
    }
    if (!isLoading && !isError && products?.length > 0) {

        content = (
            <div className='grid grid-cols-1 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4'>
                {products.map((item, i) => (
                    <div key={i} className="seller grid grid-cols-2 gap-2">
                        <div className='w-full h-auto grid content-center'>
                            <Link to={`/products/${item.id}`}>
                                <img className='object-cover  w-full' src={item.cardImg} alt="" />
                            </Link>
                        </div>
                        <div className='w-full h-auto grid content-center'>
                            <div>
                                <Link to={`/products/${item.id}`} className="text-link">
                                    <p className='font-normal'>{item.name.length > 32 ? item.name.substring(32, 0) + ".." : item.name}</p>
                                </Link>
                                <p className='font-normal line-through text-red-500'>{Number(item.price) < Number(item.prvPrice) && ('price: ' + item.prvPrice + `${t('home.obPd.p.tk')}`)}</p>
                                <p className='font-normal text-gray-500 mb-1'>price: {item.price} {t('home.obPd.p.tk')}</p>
                                <button onClick={() => handleAddToCart(item)} className='w-26 h-7 bg-bnd-2 text-sm text-white rounded-md px-2'>{t('home.obPd.p.atc')}</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    return (
        <div className="bg-light py-5">
            <div className="container mx-auto md:px-5">
                <div className="titlee">
                    <h2 className='font-bold font-poppins color-bnd-1 text-4xl py-3'>{t('home.obPd.hadelineMS')}</h2>
                </div>
                <div>
                    {content}
                </div>
            </div>
        </div>
    );
};

export default BestSeller;